import { combineReducers } from 'redux';

// custom reducers
import analytics from './analytics';
import auth from './auth';
import errors from './errors';
import inactivity from './inactivity';
import leadTable from './leadTable';
import patientSignup from './patientSignup';
import newAppointmentForm from './newAppointmentForm';
import providers from './providers';
import menu from "./menu";
import sessionTable from './sessionTable';
import stagingGateway from './stagingGateway';
// services
import {apiSlice} from '../services/apiSlice';
import {authApi} from '../services/authApi';

const reducer = combineReducers({
  analytics,
  auth,
  errors,
  inactivity,
  leadTable,
  newAppointmentForm,
  patientSignup,
  providers,
  sessionTable,
  stagingGateway,
  [apiSlice.reducerPath]: apiSlice.reducer,
  [authApi.reducerPath]: authApi.reducer,
  menu
});

export default reducer;
